import Phaser from "phaser";

import MainScene from './MainScene';

import { Scene } from '../utils/consts';
import { Mode } from '../types';
import i18n from '../../assets/i18n.json';
import Sdk from "../sdk";
import Button from "../button";
import debounce from "../utils/debounce";
import { LeaderboardScene } from "./LeaderboardScene";

let scale = 1;

export default class HomeScene extends Phaser.Scene {
    private leaderboardButton?: Button;
    private multiplayerButton?: Button;
    private singleplayerButton?: Button;
    private resizeObserver?: ResizeObserver;

    constructor() {
        super(Scene.HOME);
    }

    create() {
        const texts = i18n[(this.registry.get('sdk') as Sdk).getLang()];

        this.singleplayerButton = new Button(this, texts.singleplayer, () => { this.onStartClick('singleplayer'); }, 'red').setPosition(this.renderer.width / 2, this.renderer.height / 3);
        this.multiplayerButton = new Button(this, texts.multiplayer, () => { this.onStartClick('multiplayer'); }, 'green').setPosition(this.renderer.width / 2, this.renderer.height / 2);
        this.leaderboardButton = new Button(this, texts.leaderboard, () => this.openLeaderboard(), 'default').setPosition(this.renderer.width / 2, this.renderer.height / 3 * 2);
        
        this.resizeObserver = new ResizeObserver(debounce(this.onResize.bind(this), 100));
        this.resizeObserver.observe(this.game.canvas);
        this.updatePositions();
    }

    private onStartClick(mode: Mode) {
        this.resizeObserver?.disconnect();
        this.game.scene.add(Scene.BOARD, new MainScene(mode), true);
        this.scene.remove();
    }

    private onResize() {
        if (this.game) {
            this.updatePositions();
        }
    }

    private updatePositions() {
        if (this.renderer.width < 700 || this.renderer.height < 700) {
            scale = 0.5;
        } else {
            scale = 1;
        }

        if (this.renderer.width > this.renderer.height) {
            this.singleplayerButton!.setPosition(this.renderer.width / 2, this.renderer.height / 4);
            this.multiplayerButton!.setPosition(this.renderer.width / 2, this.renderer.height / 2);
            this.leaderboardButton!.setPosition(this.renderer.width / 2, this.renderer.height / 4 * 3);
        } else {
            this.singleplayerButton!.setPosition(this.renderer.width / 2, this.renderer.height / 3);
            this.multiplayerButton!.setPosition(this.renderer.width / 2, this.renderer.height / 2);
            this.leaderboardButton!.setPosition(this.renderer.width / 2, this.renderer.height / 3 * 2);
        }
        
        this.singleplayerButton!.setScale(scale);
        this.multiplayerButton!.setScale(scale);
        this.leaderboardButton!.setScale(scale);
    }

    private openLeaderboard() {
        this.resizeObserver?.disconnect();
        this.game.scene.add(Scene.LEADERBOARD, new LeaderboardScene(), true);
        this.scene.remove();
    }
}